import type {ReactElement} from 'react';

export const WIZARD_LOGO_ASSET = 'logo-postermaker-dark.svg';

export interface SocialMediaWizardHeaderProps {
  isSmallScreen: boolean;
  onBackClick?: () => void;
  isBackDisabled?: boolean;
  onLogoClick: () => void;
  desktopTitle?: string;
  isDesktopTitleVisible?: boolean;
  hasShadow?: boolean;
  mobileTitle?: string;
  rightSlot?: ReactElement | null;
}
